import { useEffect, useState } from 'react'

export const SIZES = {
  DESKTOP: 1024,
  TABLET: 768,
  MOBILE_L: 425,
  MOBILE_M: 375,
  MOBILE_S: 320,
}

export const DEVICE = {
  TABLET: 'tablet',
}

export const useCheckMobile = (device?: string | null, maxWidth?: number) => {
  const [width, setWidth] = useState(window.innerWidth)

  const handleWindowResize = () => setWidth(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  })

  if (device && device === DEVICE.TABLET) {
    return SIZES.TABLET <= width && width <= SIZES.DESKTOP
  }

  return width <= (maxWidth ? maxWidth : SIZES.TABLET)
}
